<template>
  <section class="completion-step">
    <div class="completion-card bg-white rounded-xl border border-slate-200/80 shadow-sm">
      <div class="completion-card__icon-circle">
        <v-icon color="#2B8A8F" size="40">{{ icons.mdiCheck }}</v-icon>
      </div>

      <h2 class="completion-card__title">
        <mrx-translation token="app.end.title"></mrx-translation>
      </h2>

      <mrx-translation
        class="completion-card__instructions"
        token="app.end.new_assessment_preferences.instructions"
      ></mrx-translation>

      <div class="completion-card__actions">
        <button
          id="return-home"
          type="button"
          class="completion-card__home"
          @click="$emit('return-home')"
        >
          <mrx-translation token="app.end.return_home.button"></mrx-translation>
        </button>
        <button
          id="new-assessment-button"
          type="button"
          class="completion-card__new-assessment"
          @click="$emit('new-assessment')"
        >
          <mrx-translation token="app.end.new_assessment_preferences.button"></mrx-translation>
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import icons from '@/mixins/icons';
import MrxTranslation from '@/components/thinkmd/mrx/translation.vue';

export default defineComponent({
  name: 'AssessmentCompleteStep',

  components: {
    MrxTranslation,
  },

  mixins: [icons],

  emits: ['new-assessment', 'return-home'],
});
</script>
